import {
  daoOAuthPermissionsGet,
  daoOauthScopesGet,
  daoOAuthClientOwnerGet,
  daoOAuthClientOwnerAdd,
  daoOAuthClientOwnerDelete,
  daoOAuthIsScopeValid
} from 'dao/oauthportal-dao';
import { setHandledErrorCodes} from 'lib/error-message-handling';

const getErrorCodesArray = () => {
  return [ 
    404
  ];
};

// ------------------------------------
// Constants
// ------------------------------------
export const OAUTHPORTAL_PERMISSIONS_GET = 'OAUTHPORTAL_PERMISSIONS_GET';
export const OAUTHPORTAL_PERMISSIONS_GET_SUCCESS = 'OAUTHPORTAL_PERMISSIONS_GET_SUCCESS';
export const OAUTHPORTAL_PERMISSIONS_GET_FAILURE = 'OAUTHPORTAL_PERMISSIONS_GET_FAILURE';

export const OAUTHPORTAL_SCOPES_GET = 'OAUTHPORTAL_SCOPES_GET';
export const OAUTHPORTAL_SCOPES_GET_SUCCESS = 'OAUTHPORTAL_SCOPES_GET_SUCCESS';
export const OAUTHPORTAL_SCOPES_GET_FAILURE = 'OAUTHPORTAL_SCOPES_GET_FAILURE';

export const OAUTHPORTAL_CLIENT_OWNER_GET = 'OAUTHPORTAL_CLIENT_OWNER_GET';
export const OAUTHPORTAL_CLIENT_OWNER_GET_SUCCESS = 'OAUTHPORTAL_CLIENT_OWNER_GET_SUCCESS';
export const OAUTHPORTAL_CLIENT_OWNER_GET_FAILURE = 'OAUTHPORTAL_CLIENT_OWNER_GET_FAILURE';

export const OAUTHPORTAL_CLIENT_OWNER_ADD = 'OAUTHPORTAL_CLIENT_OWNER_ADD';
export const OAUTHPORTAL_CLIENT_OWNER_ADD_SUCCESS = 'OAUTHPORTAL_CLIENT_OWNER_ADD_SUCCESS';
export const OAUTHPORTAL_CLIENT_OWNER_ADD_FAILURE = 'OAUTHPORTAL_CLIENT_OWNER_ADD_FAILURE';

export const OAUTHPORTAL_CLIENT_OWNER_DELETE = 'OAUTHPORTAL_CLIENT_OWNER_DELETE';
export const OAUTHPORTAL_CLIENT_OWNER_DELETE_SUCCESS = 'OAUTHPORTAL_CLIENT_OWNER_DELETE_SUCCESS';
export const OAUTHPORTAL_CLIENT_OWNER_DELETE_FAILURE = 'OAUTHPORTAL_CLIENT_OWNER_DELETE_FAILURE';

export const OAUTHPORTAL_SCOPE_IS_VALID = 'OAUTHPORTAL_SCOPE_IS_VALID';
export const OAUTHPORTAL_SCOPE_IS_VALID_SUCCESS = 'OAUTHPORTAL_SCOPE_IS_VALID_SUCCESS';
export const OAUTHPORTAL_SCOPE_IS_VALID_FAILURE = 'OAUTHPORTAL_SCOPE_IS_VALID_FAILURE';

// ------------------------------------
// Initial State
// ------------------------------------
export const initialState = {
  data: {
    oauthPortalPermissions: {},
    scopes: [],
    owners: []
  },

  // generic or global properties go here
  isLoading: false,
};

// ------------------------------------
// Selectors
// ------------------------------------
export const orgPortalPermissionsIsLoading = (state) => state.oauthPortal && state.oauthPortal.isLoading;
export const orgPortalPermissionWrite = (state) => (state.oauthPortal && state.oauthPortal.data && state.oauthPortal.data.write) || false;
export const orgPortalScopes = (state) => (state.oauthPortal && state.oauthPortal.data && state.oauthPortal.data.scopes) || [];
export const currentClientOwners = (state) => (state.oauthPortal && state.oauthPortal.data && state.oauthPortal.data.owners) || [];

// ------------------------------------
// Actions
// ------------------------------------
export const orgPortalPermissionsGetSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_PERMISSIONS_GET_SUCCESS,
  payload,
});

export const orgPortalPermissionsGetFailure = (payload = {}) => ({
  type: OAUTHPORTAL_PERMISSIONS_GET_FAILURE,
  payload,
});

export const oauthPortalPermissionsGet = (clientId = '') => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_PERMISSIONS_GET,
  });
  return daoOAuthPermissionsGet(clientId)
    .then(
      response => dispatch(orgPortalPermissionsGetSuccess(response.data)),
      ex => dispatch(orgPortalPermissionsGetFailure(ex)),
    );
};

export const orgPortalScopesGetSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPES_GET_SUCCESS,
  payload,
});

export const orgPortalScopesGetFailure = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPES_GET_FAILURE,
  payload,
});

export const oauthPortalScopesGet = () => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_SCOPES_GET,
  });
  return daoOauthScopesGet()
    .then(
      response => dispatch(orgPortalScopesGetSuccess(response.data)),
      ex => dispatch(orgPortalScopesGetFailure(ex)),
    );
};

export const orgPortalClientOwnerGetSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_GET_SUCCESS,
  payload,
});

export const orgPortalClientOwnerGetFailure = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_GET_FAILURE,
  payload,
});

export const oauthPortalClientOwnerGet = (clientId = '') => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_CLIENT_OWNER_GET,
  });
  return daoOAuthClientOwnerGet(clientId)
    .then(
      response => dispatch(orgPortalClientOwnerGetSuccess(response.data)),
      ex => dispatch(orgPortalClientOwnerGetFailure(ex)),
    );
};

export const orgPortalClientOwnerAddSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_ADD_SUCCESS,
  payload,
});

export const orgPortalClientOwnerAddFailure = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_ADD_FAILURE,
  payload,
});

export const oauthPortalClientOwnerAdd = (clientId = '', ownerData = '') => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_CLIENT_OWNER_ADD,
  });
  setHandledErrorCodes(getErrorCodesArray());
  return daoOAuthClientOwnerAdd(clientId, ownerData)
    .then(
      response => dispatch(orgPortalClientOwnerAddSuccess(response.data)),
      ex => {
        dispatch(orgPortalClientOwnerAddFailure(ex));
        return Promise.reject(ex);}
    );
};

export const orgPortalClientOwnerDeleteSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_DELETE_SUCCESS,
  payload,
});

export const orgPortalClientOwnerDeleteFailure = (payload = {}) => ({
  type: OAUTHPORTAL_CLIENT_OWNER_DELETE_FAILURE,
  payload,
});

export const oauthPortalClientOwnerDelete = (clientId = '', ownerData = '') => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_CLIENT_OWNER_DELETE,
  });
  return daoOAuthClientOwnerDelete(clientId, ownerData)
    .then(
      response => dispatch(orgPortalClientOwnerDeleteSuccess(response.data)),
      ex => dispatch(orgPortalClientOwnerDeleteFailure(ex)),
    );
};

export const oauthPortalScopeIsValidSuccess = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPE_IS_VALID_SUCCESS,
  payload,
});

export const oauthPortalScopeIsValidFailure = (payload = {}) => ({
  type: OAUTHPORTAL_SCOPE_IS_VALID_FAILURE,
  payload,
});

export const oauthPortalScopeIsValid = (scopeId) => (dispatch) => {
  dispatch({
    type: OAUTHPORTAL_SCOPE_IS_VALID,
  });
  return daoOAuthIsScopeValid(scopeId)
    .then(
      response => dispatch(oauthPortalScopeIsValidSuccess(response.data)),
      ex => dispatch(oauthPortalScopeIsValidFailure(ex)),
    );
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [OAUTHPORTAL_PERMISSIONS_GET]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_PERMISSIONS_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [OAUTHPORTAL_PERMISSIONS_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [OAUTHPORTAL_SCOPES_GET]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_SCOPES_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          scopes: action.payload
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [OAUTHPORTAL_SCOPES_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [OAUTHPORTAL_CLIENT_OWNER_GET]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_CLIENT_OWNER_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          owners: action.payload
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [OAUTHPORTAL_CLIENT_OWNER_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [OAUTHPORTAL_CLIENT_OWNER_ADD]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_CLIENT_OWNER_ADD_SUCCESS]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    };
  },
  [OAUTHPORTAL_CLIENT_OWNER_ADD_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [OAUTHPORTAL_CLIENT_OWNER_DELETE]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_CLIENT_OWNER_DELETE_SUCCESS]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    };
  },
  [OAUTHPORTAL_CLIENT_OWNER_DELETE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [OAUTHPORTAL_SCOPE_IS_VALID]: (state) => ({...state, isLoading: true}),
  [OAUTHPORTAL_SCOPE_IS_VALID_SUCCESS]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    };
  },
  [OAUTHPORTAL_SCOPE_IS_VALID_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const oAuthPortalPermissionsReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};

export default oAuthPortalPermissionsReducer;
